import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    PxButtonComponent,
    PxDownloadLinkComponent,
    PxHelpIconComponent,
    PxTooltipDirective,
    PxUploadComponent,
} from './components';
import { PxDownloadLinkConfigService } from './config/px-download-link-config.service';
import { DropZoneDirective } from './directives/drop-zone.directive';
import { IPxUploadService, PxJwtTokenProviderService, PxUploadService } from './services';

const IMPORTS_EXPORT = [
    PxButtonComponent,
    PxDownloadLinkComponent,
    PxUploadComponent,
    PxHelpIconComponent,
    PxTooltipDirective,
];

@NgModule({
    declarations: [...IMPORTS_EXPORT, DropZoneDirective],
    imports: [CommonModule, FormsModule],
    providers: [PxJwtTokenProviderService],
    exports: [...IMPORTS_EXPORT],
})
export class PxButtonsModule {
    static forRoot(
        downloadLinkConfigService: Partial<PxDownloadLinkConfigService>,
        jwtProviderService?: Type<PxJwtTokenProviderService>,
        uploadService?: Type<IPxUploadService>
    ): ModuleWithProviders<PxButtonsModule> {
        return {
            ngModule: PxButtonsModule,
            providers: [
                { provide: PxDownloadLinkConfigService, useValue: downloadLinkConfigService },
                { provide: PxJwtTokenProviderService, useClass: jwtProviderService },
                { provide: PxUploadService, useExisting: uploadService },
            ],
        };
    }
}
